<template>
    <status-badge :label="resolved.label" :icon="resolved.icon" :color="resolved.color" :color-class="resolved.colorClass" :addon="resolved.addon" />
</template>

<script>
  import StatusBadge from './StatusBadge'
  import { met, tpl } from '../StatusBadge'
  export default {
    name: 'OrderStatusBadge',
    components: {StatusBadge},
    props: {
      order: {},
    },
    computed: {
      resolved() {
        if (this.order.transactionnum === null)
          return {colorClass: 'warning', icon: 'fa fa-pause', label: 'Orders.statusNotOrdered'};

        if (Array.isArray(this.customStatuses)) {
          for(const config of this.customStatuses) {
            if (met(config.conditions, this.order)) {
              const {style, icon, label, color} = config;
              return {colorClass: style, icon, color, label: tpl(this.$t(label), this.order)};
            }
          }
        }

        switch (this.order.status) {
          case 0: return {colorClass: 'warning', icon:'fa fa-inbox', label: 'Orders.statusReceived'};
          case 1:
            return typeof this.addon !== 'undefined'
              ? {colorClass: 'info', icon: 'fa fa-cogs', label: 'Orders.statusInProduction'}
              : {colorClass: 'warning', icon: 'fa fa-clock', label: 'Orders.statusInProgress'}
          case 2:
            return {colorClass: 'warning', icon:'fa fa-clock', label: 'Orders.statusOnHold'};
          case 3:
            return {colorClass: 'danger', icon:'fa fa-times', label: 'Orders.statusCancelled'};
          case 4:
            return {colorClass: 'success', icon:'fa fa-check', label: 'Orders.statusClosed'};
          case 9:   // Partly Delivered
            return {colorClass: 'info', icon:'fa fa-truck', label: 'Orders.statusPartlyDelivered'};
          case 10:  // Partly Invoiced / Cancelled
            return {colorClass: 'danger', icon:'fa fa-times', label: 'Orders.statusPartlyDeliveredCancelled'};
          case 11:   // Partly Delivered
            return {colorClass: 'info', icon:'fa fa-truck', label: 'Orders.statusPartlyDeliveredClosed'};
          case 12:  // Delivered
            return {colorClass: 'success', icon:'fa fa-truck', label: 'Orders.statusDelivered'};
          case 13:  // Partly Invoiced
          case 15:  // Partly Invoiced / Closed
          case 16:  // Invoiced
            return {colorClass: 'success', icon:'fa fa-check', label: 'Orders.statusCompleted'};
          case 14:  // Partly Invoiced / Cancelled
            return {colorClass: 'danger', icon:'fa fa-times', label: 'Orders.statusInvoicedCancelled'};
          default:
            return {colorClass: 'unknown', icon: 'fa fa-unknown', label: 'Unknown ' + this.order.status};
        }
      },
      addon() {
        return this.order.orderstatus ? (typeof this.orderStatusCodes[this.order.orderstatus] === 'string' ? this.orderStatusCodes[this.order.orderstatus] : true) : ''
      },
      orderStatusCodes() {
        return typeof this.$root.orderStatusCodes == 'object' ? this.$root.orderStatusCodes : {};
      },
      customStatuses() {
        return this.order.workflow && ((this.$root.workflowTypes || {})[this.order.workflow] || {}).orderStatuses || [];
      }
    }
  }
</script>

<style scoped>

</style>
